module.exports = __webpack_public_path__ + "static/img/b2.39a2229.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/b2.png
// module id = kOVK
// module chunks = 0